import { CancelButton } from "../CancelButton/CancelButton";
import { UndoRedo } from "../UndoRedo/UndoRedo";
import { DoneButton } from "../DoneButton/DoneButton";
import ManualModeSwitch from "../../ManualModeSwitch/ManualModeSwitch";
import { Divider } from "antd";
import { LeftButton } from "../LeftButton/LeftButton";
import { RightButton } from "../RightButton/RightButton";
import ToggleHiddenButton from "../../ToggleHiddenButton/ToggleHiddenButton";
import ResetButton from "../ResetButton/ResetButton";

export function LocationModeBottomPanelContent() {
  return (
    <>
      <ManualModeSwitch />
      <Divider type="vertical" />
      <LeftButton />
      <ToggleHiddenButton />
      <RightButton />
      <Divider type="vertical" />
      <UndoRedo />
      <ResetButton />
      <Divider type="vertical" />
      <CancelButton />
      <DoneButton />
    </>
  );
}
